import { render } from "./EducationUserHeader.vue?vue&type=template&id=1164598d"
import script from "./EducationUserHeader.vue?vue&type=script&lang=js"
export * from "./EducationUserHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__